/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GenerateTransactionPlanInput = {
  /** The payment method card to use. */
  readonly paymentMethodCardId?: string | null | undefined;
  /** Tip, in cents. Added on top of the order total for the amount to plan. */
  readonly tip?: number | null | undefined;
  /** Whether to apply stored-value credit. */
  readonly useCredit?: boolean | null | undefined;
  /** Whether to apply HSA/FSA (Flex). */
  readonly useHsa?: boolean | null | undefined;
};

export type PaymentBreakdownQueryVariables = Exact<{
  input: Types.GenerateTransactionPlanInput;
}>;

export type PaymentBreakdownQuery = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly transactionPlan:
      | { readonly __typename: 'CustomerNotOnboardedError'; readonly errorMessage: string }
      | { readonly __typename: 'OrderMissingTotalError'; readonly errorMessage: string }
      | {
          readonly __typename: 'TransactionPlanResult';
          readonly transactionPlan: ReadonlyArray<{
            readonly amountInCents: number;
            readonly automaticCapture: boolean | null;
            readonly processor: string;
          }>;
        }
      | null;
  } | null;
};

export const PaymentBreakdownDocument = gql`
  query PaymentBreakdown($input: GenerateTransactionPlanInput!) {
    cart {
      id
      __typename
      transactionPlan(input: $input) {
        __typename
        ... on TransactionPlanResult {
          transactionPlan {
            amountInCents
            automaticCapture
            processor
          }
        }
        ... on CustomerNotOnboardedError {
          errorMessage
        }
        ... on OrderMissingTotalError {
          errorMessage
        }
      }
    }
  }
`;

export function usePaymentBreakdownQuery(
  options: Omit<Urql.UseQueryArgs<PaymentBreakdownQueryVariables>, 'query'>,
) {
  return Urql.useQuery<PaymentBreakdownQuery, PaymentBreakdownQueryVariables>({
    query: PaymentBreakdownDocument,
    ...options,
  });
}
